import { Switch } from "@headlessui/react";
import { concatenateClassnames } from "../../lib/utilities";

import { useTheme } from "next-themes";

import { moonSVG, sunSVG } from "./svg";

// Dark mode Toggle is running independant form the standard toggle UI file. As a result, changes to the standard toggle will also need to be made here.

export default function DarkLightMode() {
  const { theme, setTheme } = useTheme();

  function changeThemeAndSymbol() {
    if (theme == "light") {
      setTheme("dark");
    } else {
      setTheme("light");
    }
  }

  return (
    <div className="flex items-center gap-2">
      <Switch
        id="themeSwitch"
        data-testid="toggleButton"
        onChange={() => {
          changeThemeAndSymbol();
        }}
        className={concatenateClassnames(
          theme == "dark" ? "darkMode bg-gray-500" : "lightMode bg-gray-300",
          "relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent focus:outline-none",
          // focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2
        )}
      >
      <span className="sr-only">Use setting</span>
      <span
        className={concatenateClassnames(
          theme == "dark" ? "translate-x-5" : "translate-x-0",
          //   'pointer-events-none relative inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out'
          "pointer-events-none relative inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out",
        )}
      >
        <span
          data-testid="sunSVG"
          className={concatenateClassnames(
            theme == "dark"
              ? "opacity-0 duration-100 ease-out"
              : "opacity-100 duration-200 ease-in",
            "absolute inset-0 flex h-full w-full items-center justify-center p-1 transition-opacity",
          )}
          aria-hidden="true"
        >
          {sunSVG}
        </span>
        <span
          data-testid="moonSVG"
          className={concatenateClassnames(
            theme == "dark"
              ? "rounded-full bg-orange-400 opacity-100 duration-200 ease-in dark:bg-orange-500"
              : "opacity-0 duration-100 ease-out",
            "absolute inset-0 flex h-full w-full items-center justify-center p-1 transition-opacity",
          )}
          aria-hidden="true"
        >
          {moonSVG}
        </span>
      </span>
    </Switch>
    </div>
  );
}
